.bn{position:absolute;}